import Header from "./Header"
import Footer from "./Footer"
import Home from "./Home"

export default function App(){
    return(
        <div >
            <Header/>
            <Home/>
            <Footer/>
        </div>
    )
}